// Íconos de la app que se suben desde el dashboard (Business.appIcons.client):
// el de la pestaña del navegador y el que usa el iPhone al "Agregar a inicio".
// index.html ya pone los de la copia guardada antes de que cargue la app; esto
// los actualiza con los recién llegados. El ícono de Android (PWA) sale del
// manifest, que sirve la API con esos mismos íconos.
export function aplicarIconosApp(restaurante) {
  const iconos = restaurante?.appIcons?.client;
  if (!iconos) return;
  const poner = (rel, href) => {
    const link = href && document.querySelector(`link[rel="${rel}"]`);
    if (link && link.getAttribute('href') !== href) link.setAttribute('href', href);
  };
  poner('icon', iconos.icon192);
  poner('apple-touch-icon', iconos.apple);
}
